import { createContext } from 'react';

const ActionsContext = createContext({
  close() {}
});

export default ActionsContext;
